var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUpdateShippingServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportUpdateShippingServiceActionView = (function(superClass) {
  extend(SupportUpdateShippingServiceActionView, superClass);

  function SupportUpdateShippingServiceActionView() {
    return SupportUpdateShippingServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportUpdateShippingServiceActionView.prototype.id = 'update_shipping';

  SupportUpdateShippingServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportUpdateShippingServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportUpdateShippingServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "update_shipping",
      service_action: I18n.t("js.modules.support.update_shipping")
    };
    return this.extendHash(hash);
  };

  SupportUpdateShippingServiceActionView.prototype.actionHandler = function(event) {
    var dealPermalink, orderId, url;
    dealPermalink = Groupon.Support.currentOrder.deal.id;
    orderId = Groupon.Support.currentOrder.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId;
    return window.open(url);
  };

  SupportUpdateShippingServiceActionView.prototype.events = {
    "click #update_shipping": "actionHandler"
  };

  return SupportUpdateShippingServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportUpdateShippingServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvdXBkYXRlX3NoaXBwaW5nX2FkZHJlc3Nfc2VydmljZV9hY3Rpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvdXBkYXRlX3NoaXBwaW5nX2FkZHJlc3Nfc2VydmljZV9hY3Rpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEseUdBQUE7RUFBQTs7O0FBQUEsNkJBQUEsR0FBZ0MsT0FBQSxDQUFRLHVCQUFSOztBQUNoQyxrQ0FBQSxHQUFxQyxPQUFBLENBQVEsaURBQVI7O0FBRS9COzs7Ozs7O21EQUNKLEVBQUEsR0FBSTs7bURBRUosVUFBQSxHQUFZLFNBQUE7SUFDVixDQUFDLENBQUMsT0FBTyxDQUFDLEtBQVYsQ0FBZ0IsQ0FBaEIsRUFBbUIsQ0FBQyxJQUFELENBQU0sQ0FBQyxNQUFQLENBQWMsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxJQUFaLENBQWQsQ0FBbkI7SUFDQSxJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtXQUNaLElBQUMsQ0FBQSxLQUFELEdBQVMsT0FBTyxDQUFDLE9BQU8sQ0FBQztFQUpmOzttREFNWixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxTQUE5QixDQUFaO0VBRE07O21EQUdSLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsR0FDRTtNQUFBLGlCQUFBLEVBQW9CLGlCQUFwQjtNQUNBLGNBQUEsRUFBaUIsSUFBSSxDQUFDLENBQUwsQ0FBTyxvQ0FBUCxDQURqQjs7V0FFRixJQUFDLENBQUEsVUFBRCxDQUFZLElBQVo7RUFKTTs7bURBTVIsYUFBQSxHQUFlLFNBQUMsS0FBRDtBQUNiLFFBQUE7SUFBQSxhQUFBLEdBQWdCLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQztJQUNsRCxPQUFBLEdBQVUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUM7SUFDdkMsR0FBQSxHQUFNLFNBQUEsR0FBVyxhQUFYLEdBQTBCLGdCQUExQixHQUEyQztXQUNqRCxNQUFNLENBQUMsSUFBUCxDQUFZLEdBQVo7RUFKYTs7bURBTWYsTUFBQSxHQUNFO0lBQUEsd0JBQUEsRUFBMkIsZUFBM0I7Ozs7O0dBekJpRDs7QUEyQnJELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
